import {toast} from 'react-toastify';
import AuthService from '../../AuthService';
const API_URL = 'https://api.rb.beeapp.es';
const token = AuthService.getToken();

class OrderService {

    static async getTotalOrders() {
        const response = await fetch(`${API_URL}/users/orders/count`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });
        const data = await response.json();
        return data || 0;
    }

    static async getTotalOrderAmount() {
        const response = await fetch(`${API_URL}/users/orders/amount`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });
        const data = await response.json();
        return data || 0;
    }

    static async createOrder(order) {
        const response = await fetch(`${API_URL}/orders/`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(order),
        });
        const data = await response.json();
        return data || [];
    }

    static async orderConfirmation(order) {
        const response = await fetch(`${API_URL}/orders/create`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(order),
        });
        const data = await response.json();
        return data || [];
    }

    static async getOrders() {
        const response = await fetch(`${API_URL}/orders/user`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });
        const data = await response.json();
        return data || [];
    }

    static async getOrder(id) {
        const response = await fetch(`${API_URL}/orders/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });
        const data = await response.json();

        return data || {};
    }

}

export default OrderService;